import * as S from './Typography.styled';

export default S.Typography;
